var map = {
	".": 8305,
	"./": 8305,
	"./App": 9555,
	"./App.js": 9555,
	"./Arrive": 6383,
	"./Arrive.js": 6383,
	"./Authentication": 6485,
	"./Authentication.js": 6485,
	"./Bookings": 5587,
	"./Bookings.js": 5587,
	"./Camping": 1654,
	"./Camping.js": 1654,
	"./CocoraValley": 1328,
	"./CocoraValley.js": 1328,
	"./Cocoraviva": 5180,
	"./Cocoraviva.js": 5180,
	"./CofeeHouse": 278,
	"./CofeeHouse.js": 278,
	"./Contact": 8779,
	"./Contact.js": 8779,
	"./Footer": 705,
	"./Footer.js": 705,
	"./Formdialog": 3869,
	"./Formdialog.js": 3869,
	"./Games": 7289,
	"./Games.js": 7289,
	"./Glamping": 4773,
	"./Glamping.js": 4773,
	"./Home": 4620,
	"./Home.js": 4620,
	"./Horsebackriding": 3552,
	"./Horsebackriding.js": 3552,
	"./Loading": 7768,
	"./Loading.js": 7768,
	"./Lodging": 513,
	"./Lodging.js": 513,
	"./NavBar": 1922,
	"./NavBar.js": 1922,
	"./NavButton": 6919,
	"./NavButton.js": 6919,
	"./Packages": 6942,
	"./Packages.js": 6942,
	"./Paginator": 6614,
	"./Paginator.js": 6614,
	"./Restaurant": 934,
	"./Restaurant.js": 934,
	"./Review": 7915,
	"./Review.js": 7915,
	"./Reviews": 594,
	"./Reviews.js": 594,
	"./ScrollToTop": 9516,
	"./ScrollToTop.js": 9516,
	"./ServiceCard": 5102,
	"./ServiceCard.js": 5102,
	"./ServiceCardV2": 154,
	"./ServiceCardV2.js": 154,
	"./Services": 9786,
	"./Services.js": 9786,
	"./SlideShow": 2624,
	"./SlideShow.js": 2624,
	"./WhoAreWe": 5177,
	"./WhoAreWe.js": 5177,
	"./context/LanguageContext": 5794,
	"./context/LanguageContext.js": 5794,
	"./context/auth/AuthContext": 9086,
	"./context/auth/AuthContext.js": 9086,
	"./context/types": 105,
	"./context/types.js": 105,
	"./fonts/Myriad Pro Bold.ttf": 2403,
	"./fonts/Myriad Pro Regular.ttf": 7876,
	"./fonts/NewsGothicCondensedBQ-Regular.otf": 4504,
	"./fonts/ShadedLarch.ttf": 8059,
	"./images/AlbertoP.jpeg": 634,
	"./images/Artesanias.png": 946,
	"./images/Arts and crafts.png": 6904,
	"./images/AtardercerPalmas.jpeg": 4601,
	"./images/Atracciones.jpeg": 9755,
	"./images/Atracciones.png": 8400,
	"./images/Attractions.png": 8265,
	"./images/Cabin.jpeg": 710,
	"./images/Camp.png": 4572,
	"./images/Campamento.png": 1324,
	"./images/CampingZone.jpeg": 2856,
	"./images/Casita del Sabor.png": 794,
	"./images/CasitaDelSabor-modified.png": 8550,
	"./images/CasitaDelSabor.jpeg": 3709,
	"./images/CertificacionPalmas.png": 9015,
	"./images/Ecological tours.png": 3115,
	"./images/Entrada.jpeg": 7336,
	"./images/EntradaParqueadero.jpeg": 6336,
	"./images/FrenteEnteroRestaurante.jpeg": 4137,
	"./images/FrenteRestaurante.jpeg": 9538,
	"./images/FrontRestaurant.jpeg": 7276,
	"./images/Glamping english.png": 9818,
	"./images/Glamping.png": 8834,
	"./images/Google_Maps_Logo_2020.svg.png": 1522,
	"./images/HorseRiding.jpeg": 7785,
	"./images/Hospedaje.png": 952,
	"./images/Instagram-Icon.png": 1440,
	"./images/Lodging.png": 8123,
	"./images/Logo vectorizado.svg": 1127,
	"./images/Logo web montañas.png": 7018,
	"./images/MapaLasPalmas.PNG": 5936,
	"./images/MariaT.jpeg": 8117,
	"./images/MariaTYAlberto.jpeg": 1624,
	"./images/Menu.pdf": 4655,
	"./images/Nursery.png": 4913,
	"./images/PALMAS DE COCORA LOGO-1.png": 6744,
	"./images/PALMAS_DE_COCORA_LOGO-1-removebg-preview.png": 6141,
	"./images/Paseos ecológicos.png": 6226,
	"./images/Restaurant.png": 5645,
	"./images/Restaurante.png": 7861,
	"./images/Vivero.png": 9157,
	"./images/WhatsApp Image 2022-10-02 at 11.50.37 PM(1).jpeg": 8578,
	"./images/WhatsApp Image 2022-10-02 at 11.50.37 PM.jpeg": 8768,
	"./images/WhatsApp Image 2022-10-02 at 11.50.40 PM.jpeg": 3130,
	"./images/WhatsApp Image 2022-10-02 at 11.50.43 PM.jpeg": 678,
	"./images/WhatsApp Image 2022-10-02 at 11.50.45 PM(1).jpeg": 3804,
	"./images/WhatsApp Image 2022-10-02 at 11.50.45 PM(2).jpeg": 4162,
	"./images/WhatsApp Image 2022-10-02 at 11.50.45 PM(3).jpeg": 8493,
	"./images/WhatsApp Image 2022-10-02 at 11.50.45 PM.jpeg": 6534,
	"./images/Who-are-we.jpeg": 7619,
	"./images/amigos.jpg": 3298,
	"./images/amor_de_luna.jpeg": 6421,
	"./images/artesanias.jpeg": 7028,
	"./images/atracciones1.jpeg": 6062,
	"./images/bebidas.png": 4449,
	"./images/brote.png": 2078,
	"./images/caballos1.jpeg": 550,
	"./images/cabana1.jpeg": 4299,
	"./images/cabana10.jpeg": 4432,
	"./images/cabana11.jpeg": 7215,
	"./images/cabana12.jpeg": 6489,
	"./images/cabana2.jpeg": 8876,
	"./images/cabana3.jpeg": 5289,
	"./images/cabana5.jpeg": 7825,
	"./images/cabana6.jpeg": 3446,
	"./images/cabana7.jpeg": 2054,
	"./images/cabana8.jpeg": 5353,
	"./images/cabana9.jpeg": 1930,
	"./images/cabin1.jpeg": 4765,
	"./images/cabin2.jpeg": 9838,
	"./images/cafe.png": 5158,
	"./images/caminata1.jpg": 3834,
	"./images/camping1.jpeg": 7805,
	"./images/camping3.jpeg": 6343,
	"./images/campingFull.jpeg": 3287,
	"./images/campingFull.jpg": 2957,
	"./images/cerrar-simbolo-de-boton-circular.png": 6405,
	"./images/coffee-g169851bf0_1280.jpg": 8531,
	"./images/colombia.png": 4023,
	"./images/ecosemilla.jpg": 5980,
	"./images/estiloPropio.jpeg": 6198,
	"./images/facebookImage.png": 7640,
	"./images/gansos1.jpeg": 9296,
	"./images/glamping1.jpeg": 2711,
	"./images/glamping10.jpeg": 4821,
	"./images/glamping11.jpeg": 8685,
	"./images/glamping12.jpeg": 2482,
	"./images/glamping13.jpeg": 1161,
	"./images/glamping14.jpeg": 1515,
	"./images/glamping15.jpeg": 4112,
	"./images/glamping16.jpeg": 4697,
	"./images/glamping17.jpeg": 1893,
	"./images/glamping18.jpeg": 3539,
	"./images/glamping19.jpeg": 999,
	"./images/glamping2.jpeg": 5295,
	"./images/glamping20.jpeg": 302,
	"./images/glamping21.jpeg": 9505,
	"./images/glamping22.jpeg": 5103,
	"./images/glamping23.jpeg": 8745,
	"./images/glamping24.jpeg": 3297,
	"./images/glamping25.jpeg": 2195,
	"./images/glamping26.jpeg": 5791,
	"./images/glamping27.jpeg": 9602,
	"./images/glamping28.jpeg": 6968,
	"./images/glamping3.jpeg": 6331,
	"./images/glamping4.jpeg": 3886,
	"./images/glamping5.jpeg": 4340,
	"./images/glamping6.jpeg": 6717,
	"./images/glamping7.jpeg": 7854,
	"./images/glamping8.jpeg": 4064,
	"./images/glamping9.jpeg": 6400,
	"./images/glampingUnified.png": 8284,
	"./images/happy-birthday.jpg": 8875,
	"./images/header1.jpg": 2450,
	"./images/header2.jpg": 1568,
	"./images/header3.jpg": 4876,
	"./images/house of flavor.png": 1933,
	"./images/icons8-percentage.gif": 2281,
	"./images/icons8-stars-96.png": 9487,
	"./images/lagoGansos.jpeg": 1249,
	"./images/logo-removebg-preview.png": 8641,
	"./images/logoFacebook.png": 495,
	"./images/logoGlamping.jpg": 586,
	"./images/logoInstagram.png": 9214,
	"./images/logoWhatsApp.png": 7690,
	"./images/menu.png": 7121,
	"./images/outsideCabin.jpeg": 7574,
	"./images/pano1.jpeg": 1659,
	"./images/pano2.jpeg": 7391,
	"./images/pano3.jpeg": 223,
	"./images/pano4.jpeg": 6695,
	"./images/pano5.jpeg": 2820,
	"./images/pano6.jpeg": 5920,
	"./images/plan_cabana.jpg": 4303,
	"./images/platoEntero.jpeg": 7096,
	"./images/postre.jpeg": 9363,
	"./images/romance.jpg": 5703,
	"./images/salento.jpg": 8289,
	"./images/ternero1.jpeg": 81,
	"./images/uk.jpg": 4320,
	"./images/valle-de-cocora-g982a52cf0_1920.jpg": 932,
	"./images/valle-del-cocora-g6b77a65af_1920.jpg": 3982,
	"./images/valley-ge1efec97d_1920.jpg": 3718,
	"./images/vivero1.jpeg": 2780,
	"./images/vivero10.jpeg": 7533,
	"./images/vivero11.jpeg": 8879,
	"./images/vivero2.jpeg": 985,
	"./images/vivero3.jpeg": 2588,
	"./images/vivero4.jpeg": 6257,
	"./images/vivero5.jpeg": 1987,
	"./images/vivero6.jpeg": 6010,
	"./images/vivero7.jpeg": 7407,
	"./images/vivero8.jpeg": 8850,
	"./images/vivero9.jpeg": 2261,
	"./images/viveroMata1.jpeg": 2079,
	"./images/viveroMata2.jpeg": 4234,
	"./images/viveroMata3.jpeg": 3634,
	"./images/viveroMata4.jpeg": 3304,
	"./images/viveroMata5.jpeg": 5252,
	"./images/viveroMata6.jpeg": 696,
	"./images/viveroMata7.jpeg": 6236,
	"./images/whatsappImage.png": 1938,
	"./images/women-1487825_960_720.jpg": 8893,
	"./index": 8305,
	"./index.js": 8305,
	"./styles/App.css": 6201,
	"./styles/AppStyle": 9866,
	"./styles/AppStyle.js": 9866,
	"./styles/ArriveStyle": 3233,
	"./styles/ArriveStyle.js": 3233,
	"./styles/BookingsStyle": 1269,
	"./styles/BookingsStyle.js": 1269,
	"./styles/CampingStyle": 2308,
	"./styles/CampingStyle.js": 2308,
	"./styles/CocoraValleyStyle": 9222,
	"./styles/CocoraValleyStyle.js": 9222,
	"./styles/CocoravivaStyle": 9397,
	"./styles/CocoravivaStyle.js": 9397,
	"./styles/CofeeHouseStyle": 8575,
	"./styles/CofeeHouseStyle.js": 8575,
	"./styles/ContacStyle": 5643,
	"./styles/ContacStyle.js": 5643,
	"./styles/Footer.css": 1173,
	"./styles/GamesStyle": 2934,
	"./styles/GamesStyle.js": 2934,
	"./styles/GlampingStyle": 840,
	"./styles/GlampingStyle.js": 840,
	"./styles/HomeStyle": 1280,
	"./styles/HomeStyle.js": 1280,
	"./styles/HorsebackridingStyle": 6631,
	"./styles/HorsebackridingStyle.js": 6631,
	"./styles/LoadingStyles.css": 3620,
	"./styles/LodgingStyle": 9431,
	"./styles/LodgingStyle.js": 9431,
	"./styles/NavButtonStyle": 7529,
	"./styles/NavButtonStyle.js": 7529,
	"./styles/NavButtonStyleCss.css": 3341,
	"./styles/NavbarStyle": 3912,
	"./styles/NavbarStyle.js": 3912,
	"./styles/PackagesStyle": 2585,
	"./styles/PackagesStyle.js": 2585,
	"./styles/PaginatorStyle.css": 1661,
	"./styles/RegionalcraftsStyle": 7240,
	"./styles/RegionalcraftsStyle.js": 7240,
	"./styles/RestaurantStyle": 2875,
	"./styles/RestaurantStyle.js": 2875,
	"./styles/Review.css": 988,
	"./styles/ReviewsStyle": 1749,
	"./styles/ReviewsStyle.js": 1749,
	"./styles/ServiceCard.css": 2868,
	"./styles/ServiceCardV2Style": 937,
	"./styles/ServiceCardV2Style.js": 937,
	"./styles/ServicesStyle": 4268,
	"./styles/ServicesStyle.js": 4268,
	"./styles/SlideShowStyle.css": 2964,
	"./styles/WhoAreWeStyle": 1733,
	"./styles/WhoAreWeStyle.js": 1733,
	"./styles/index.css": 9174,
	"./styles/sizes": 8254,
	"./styles/sizes.js": 8254,
	"./text/ArriveWords": 9902,
	"./text/ArriveWords.js": 9902,
	"./text/BookingWords": 3633,
	"./text/BookingWords.js": 3633,
	"./text/CampingWords": 8210,
	"./text/CampingWords.js": 8210,
	"./text/CocoraValleyWords": 6030,
	"./text/CocoraValleyWords.js": 6030,
	"./text/CoffeHouseWords": 6681,
	"./text/CoffeHouseWords.js": 6681,
	"./text/ContactWords": 1499,
	"./text/ContactWords.js": 1499,
	"./text/FooterWords": 540,
	"./text/FooterWords.js": 540,
	"./text/FormDialogWords": 9205,
	"./text/FormDialogWords.js": 9205,
	"./text/GamesWords": 1561,
	"./text/GamesWords.js": 1561,
	"./text/HomeWords": 1457,
	"./text/HomeWords.js": 1457,
	"./text/HorsebackridingWords": 8245,
	"./text/HorsebackridingWords.js": 8245,
	"./text/NavbarWords": 9059,
	"./text/NavbarWords.js": 9059,
	"./text/PackagesWords": 9425,
	"./text/PackagesWords.js": 9425,
	"./text/RegionalcraftsWords": 9033,
	"./text/RegionalcraftsWords.js": 9033,
	"./text/RestaurantWords": 6741,
	"./text/RestaurantWords.js": 6741,
	"./text/WhoAreWeWords": 4960,
	"./text/WhoAreWeWords.js": 4960,
	"./text/lodgingWords": 2476,
	"./text/lodgingWords.js": 2476,
	"./utils/setAuthToken": 7966,
	"./utils/setAuthToken.js": 7966
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 407;